import { gql } from "@apollo/client";
import IntelicheckApi, { DocumentData } from "domain/barcode-scanner/api/intelicheck.api";
import { ScannedData } from "domain/barcode-scanner/types";
import client from '../../graphql/clientAdmin';
import { CompanySettings } from "domain/shared/types/settings";

type Result = { idVerification: {scandit: boolean | undefined, intelicheck: boolean | undefined, intellicheck_workflow_response: "passed" | "flagged" | "failed" | undefined }, intellicheckResponse: any};

export class IdValidateProcess {
  private idVerification: "scandit" | "intellicheck" | undefined
  private static _instance: IdValidateProcess;

  constructor(companySettings?: CompanySettings) {
    this.idVerification = this.getSettings(companySettings);
  }

  public static instance(companySettings?: CompanySettings): IdValidateProcess {
    if (!this._instance) this._instance = new IdValidateProcess(companySettings);
    return this._instance;
  }

  isIntellicheck = () => this.idVerification === 'intellicheck';
  // isScandit = () => this.idVerification === 'scandit';

  private getSettings(companySettings?: CompanySettings) {
    if (!companySettings) return undefined;
    const { id_verification } = companySettings;
    return id_verification;
  }

  private verifyIntellicheck(data: DocumentData) {
    if (!this.isIntellicheck()) return undefined;

    const { processResult } = data.idcheck.data;
    return processResult == 'DocumentProcessOK';
  }

  async verify(scandit: ScannedData, leadId = 0, creation = false): Promise<Result | undefined> {
    if (!this.idVerification) throw new Error('No companies settings');

    let intellicheckResponse: DocumentData | undefined = undefined;
    let intellicheckWorkflowResponse: "passed" | "flagged" | "failed" | undefined = undefined;
    const { isVerify, pictures } = scandit;

    if (this.isIntellicheck()) {
      intellicheckResponse = await IntelicheckApi.run(pictures);

      if (!intellicheckResponse) throw new Error('Intelicheck Failed');

      // TODO: if is creation flow just don't run it from here, run it after creating
      if (!creation) {
        const response = await client.mutate<any>({ 
          mutation: RunWorkflowFromEntity,
          fetchPolicy: 'network-only',
          variables:  {leadId, params: { ...intellicheckResponse }}
        });
  
        intellicheckWorkflowResponse = response.data?.runWorkflowFromEntity?.report;
      }
    }

    if (isVerify == null) throw new Error('Scandit Failed');

    const intelicheckValid = this.verifyIntellicheck(intellicheckResponse!);

    return  { idVerification: { scandit: isVerify, intelicheck: intelicheckValid, intellicheck_workflow_response: intellicheckWorkflowResponse }, intellicheckResponse };
  }
}

export const RunWorkflowFromEntity = gql`
  mutation RunWorkflowFromEntity($leadId: ID!, $params: Mixed!) {
    runWorkflowFromEntity(
      input: {
        entity_namespace: "lead"
        entity_id: $leadId
        action: "after-id-verification"
        params: $params
      }
    )
  }
`;